import { customerStorageApi } from "@/api";
import type {
  ICustomerStorage,
  ICustomerStorageUsage,
  ICustomerStorageUsageStatus,
  TGenericCustomerStorageRequest,
} from "./types";

export const getCustomerStorageQuery = (
  url: string,
): Promise<ICustomerStorage> =>
  customerStorageApi
    .request<ICustomerStorage>({
      url,
      method: "get",
    })
    .then((r) => r.data);

export const genericCustomerStorageRequest = <T>({
  requestProps,
  data,
  headers,
  options,
}: TGenericCustomerStorageRequest) =>
  customerStorageApi
    .request<T>({
      url: requestProps?.uri,
      method: requestProps?.method,
      headers,
      //TODO: possible to define data type for generic request?
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      data,
      ...options,
    })
    .then((r) => r.data);

export const getCustomerStorageUsageStatus =
  (): Promise<ICustomerStorageUsageStatus> =>
    customerStorageApi
      .get<ICustomerStorageUsageStatus>(
        "v1/customer-storage-overview/usage-status",
      )
      .then((r) => r.data);

export const getCustomerStorageUsage = (): Promise<ICustomerStorageUsage> =>
  customerStorageApi
    .get<ICustomerStorageUsage>(`v1/customer-storage-overview/usages`)
    .then((r) => r.data);
